import { Reducer } from '@reduxjs/toolkit'

import { IHoliday } from '../Client/IHoliday'

import {
  TActionTypes,
  GET_HOLIDAYS,
  GET_HOLIDAYS_FAILURE,
  GET_HOLIDAYS_SUCCESS,
} from './ActionTypes'

interface IState {
  list?: IHoliday[]
  isLoading: boolean
  error: boolean
}

const initialState: IState = {
  isLoading: false,
  error: false,
  list: undefined,
}

export const holidayReducer: Reducer<IState, TActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_HOLIDAYS:
      return {
        ...state,
        isLoading: true,
      }
    case GET_HOLIDAYS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        list: action.payload.holidays,
      }
    case GET_HOLIDAYS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      }
    default:
      return state
  }
}
